import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export function useAdminContent() {
  const [content, setContent] = useState(null);
  const reload = useCallback(() => {
    api.get("/admin/content").then((r) => setContent(r.data)).catch(() => setContent(false));
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return { content, reload };
}

export const AdminTitle = ({ eyebrow, title, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
    <div>
      <p className="text-xs uppercase font-mono tracking-[0.3em] text-brass">{eyebrow}</p>
      <h1 className="mt-2 font-serif text-3xl font-bold text-cream">{title}</h1>
    </div>
    <div className="flex gap-3">{children}</div>
  </div>
);
